import client from '../client';

export const _getNotes = (type, typeid) => {
  return client.get(`notes/${type}/${typeid}`, {}, { credentials: 'omit' });
};

export const _addNote = (payload) => {
  return client.post(`note`, payload, { credentials: 'omit' });
};

export const _updateNote = (noteId, payload) => {
  return client.post(`note/${noteId}`, payload, { credentials: 'omit' });
};

export const _deleteNote = (noteId) => {
  return client.delete(`note/${noteId}`, {}, { credentials: 'omit' });
};
